import React from "react";
import { motion } from "framer-motion";
import { Trash2 } from "lucide-react";
import "./Dashboard.css";

/**
 * ResponseActions - Action buttons for response card (Edit/Export and Remove)
 * @param {boolean} disabled - Whether buttons should be disabled
 * @param {boolean} hasContent - Whether response has content to edit/export
 * @param {boolean} isLoading - Whether response is currently loading
 * @param {Function} onEdit - Callback when Edit/Export button is clicked
 * @param {Function} onRemove - Callback when Remove button is clicked
 */
export default function ResponseActions({
  disabled = false,
  hasContent = false,
  isLoading = false,
  isGridLoading = false,
  onEdit,
  onRemove,
  editLabel = "Edit / Export"
}) {
  const isEditDisabled = disabled || !hasContent || isLoading;

  // Only show "Complete" while the overall query is still loading (transient session state)
  const showStatus = isGridLoading && hasContent;

  return (
    <div className="response-actions">
      <motion.button
        className="response-btn"
        whileHover={isEditDisabled ? {} : { scale: 1.05 }}
        whileTap={isEditDisabled ? {} : { scale: 0.95 }}
        onClick={onEdit}
        disabled={isEditDisabled}
        style={{
          opacity: isEditDisabled ? 0.6 : 1,
          cursor: isEditDisabled ? 'not-allowed' : 'pointer'
        }}
      >
        {editLabel}
      </motion.button>

      <div className="response-actions-right">
        {/* Status moved to the card header. These two branches intentionally
            render nothing so the Remove button stays hidden under exactly the
            same conditions as before. */}
        {isLoading ? null : showStatus ? null : (
          <motion.button
            className="response-delete-btn"
            onClick={onRemove}
            whileHover={disabled ? {} : { scale: 1.2, rotate: 10 }}
            whileTap={disabled ? {} : { scale: 0.9 }}
            disabled={disabled}
            style={{
              opacity: disabled ? 0.6 : 1,
              cursor: disabled ? 'not-allowed' : 'pointer'
            }}
          >
            <Trash2 size={18} />
          </motion.button>
        )}
      </div>
    </div>
  );
}

